import { Component, OnInit,TemplateRef } from '@angular/core';
import { Router, ActivatedRoute } from "@angular/router";
import { BsModalService, BsModalRef } from 'ngx-bootstrap/modal';
import { SportService } from '../services/sport.service';
import { ToastrService } from 'ngx-toastr';
@Component({
  selector: 'app-footer-main',
  templateUrl: './footer-main.component.html',
  styleUrls: ['./footer-main.component.scss']
})
export class FooterMainComponent implements OnInit {
  modalRef: BsModalRef;
  data: any;
  allSportsList: any;
  qt: any = false;
  iUrl: any;
  constructor(private router: Router,private modalService: BsModalService,private route: ActivatedRoute,private sportService: SportService, private toastr: ToastrService ) { 
    let a  = window.location.pathname.split('/');
    this.data = a[1]
  }

  ngOnInit(): void {
    this.getAllSportsListData();
  }
  getAllSportsListData() {
    let userData = {};
    this.sportService.getAllSportsList(userData).subscribe(res => {
      this.allSportsList = res.data;
      this.qt = (this.allSportsList).some(el => el.name === "QTech");
    })
  }
  aviator() {
    let data = {
      gameId: 'SPB-aviator',
      providerCode: "SPB"
    }
    this.sportService.qtechLaunch(data).subscribe((res) => {
      if (res.status) {
        this.iUrl = res.data.url;
        window.open(this.iUrl, "_blank")
      } else {
        this.toastr.error(res.msg)
      }
    })
  }
  dashboard(){
    this.router.navigate(['dashboard'])
  }
  
  inplay(){
    this.router.navigate(['inplay'])
  }
  openModalLoginCnfm(loginCnfm: TemplateRef<any>) {
    this.modalRef = this.modalService.show(
      loginCnfm,
      Object.assign({}, { class: 'loginCnfm-modal modal-lg',ignoreBackdropClick: true })
    );
  }
  login(){
    this.router.navigate(['login'])
  }
}
